import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiData from '../../services/api_data';

/**
 * Fetches the current user's clients and stores them in Redux (sorted, active only).
 * Used by Router so getData() can read from store instead of calling the API every time.
 */
export const fetchUserClients = createAsyncThunk(
    'userClients/fetch',
        async (userId, { rejectWithValue }) => {
        try {
            const response = await apiData.getUserClientsList(userId);
            if (!response || !response[0]) return { userId, clients: [] };
            const sorted = (response[0].usersClientsClients || []).sort(
                (a, b) => (a.client?.clientName || '').localeCompare(b.client?.clientName || '')
            );
            const activeClients = sorted.filter(
                (c) => c.client && c.client.active === true
            );
            return { userId, clients: activeClients };
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const userClientsSlice = createSlice({
    name: 'userClients',
    initialState: {
        clients: [],
        userId: null,
        loading: false,
        error: null,
    },
    reducers: {
        clearUserClients: (state) => {
            state.clients = [];
            state.userId = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserClients.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserClients.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.userId = action.payload.userId;
                state.clients = action.payload.clients;
            })
            .addCase(fetchUserClients.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error;
            });
    },
});

export const { clearUserClients } = userClientsSlice.actions;
export default userClientsSlice.reducer;
